import { useEffect } from 'react';

import { useSSOAuth } from 'modules/auth/hooks/useSSOAuth';

export interface RedirectToAuthPageProps {
  customSignIn?: () => void;
}

export const RedirectToAuthPage = ({
  customSignIn,
}: RedirectToAuthPageProps) => {
  const { handleSignIn } = useSSOAuth();

  const signIn = customSignIn ?? handleSignIn;

  useEffect(signIn);

  return null;
};
